export const createBasketModel = (set) => ({
  basket: [],
  setBasket: (basketOrUpdater) =>
    set((state) => ({
      basket:
        typeof basketOrUpdater === 'function'
          ? basketOrUpdater(state.basket)
          : basketOrUpdater,
    })),
  addToBasket: (experience, filters) =>
    set((state) => ({
      basket: [
        ...state.basket,
        { ...experience, filters, internalId: crypto.randomUUID() },
      ],
    })),
  removeFromBasket: (experience) =>
    set((state) => ({
      basket: state.basket.filter(
        (basketExperience) =>
          basketExperience.internalId !== experience.internalId,
      ),
    })),
  updateInBasket: (experience) =>
    set((state) => ({
      basket: state.basket.map((basketExperience) =>
        basketExperience.internalId === experience.internalId
          ? experience
          : basketExperience,
      ),
    })),
  resetBasket: () => set({ basket: [] }),
});
